import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import logo from '../../assets/images/mb.jpg';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { Dropdown } from '@mui/base/Dropdown';
import { Menu } from '@mui/base/Menu';
import { MenuButton } from '@mui/base/MenuButton';
import { MenuItem, menuItemClasses } from '@mui/base/MenuItem';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import {
	agentbookinghistoryDispatch,
	agenttransactionhistoryDispatch,
	walletBalanceAgentDispatch,
} from '../../reducers/UserReducer';
import { useDispatch, useSelector } from 'react-redux';

const drawerWidth = 240;
const InternalLink = styled(ListItem)(({ theme }) => ({
	'& .Mui-selected': {
		backgroundColor: 'rgba(255, 255, 255, 0.16)',
		color: 'white',
		'& .MuiListItemIcon-root': {
			color: 'white',
		},
	},
	// backgroundColor: 'red',
	color: 'white',
	'& .MuiListItemIcon-root': {
		color: 'white',
		minWidth: 40,
	},
	'&$selected:hover': {
		backgroundColor: 'rgba(255, 255, 255, 0.16)',
		color: 'white',
		'& .MuiListItemIcon-root': {
			color: 'white',
		},
	},
	'&:hover': {
		backgroundColor: 'rgba(255, 255, 255, 0.16)',
		color: 'white',
		'& .MuiListItemIcon-root': {
			color: 'white',
		},
	},
	'& .MuiTypography-root': {
		fontSize: 15,
	},
}));
const blue = {
	50: '#F0F7FF',
	100: '#DAECFF',
	200: '#99CCF3',
	300: '#66B2FF',
	400: '#3399FF',
	500: '#007FFF',
	600: '#0072E5',
	900: '#003A75',
};

const grey = {
	50: '#f6f8fa',
	100: '#eaeef2',
	200: '#d0d7de',
	300: '#afb8c1',
	400: '#8c959f',
	500: '#6e7781',
	600: '#57606a',
	700: '#424a53',
	800: '#32383f',
	900: '#24292f',
};

const StyledListbox = styled('ul')(
	({ theme }) => `
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 6px;
  margin: 12px 0;
  min-width: 200px;
  border-radius: 12px;
  overflow: auto;
  outline: 0px;
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  box-shadow: 0px 2px 16px ${
		theme.palette.mode === 'dark' ? grey[900] : grey[200]
	};
  z-index: 1;
  `
);

const StyledMenuItem = styled(MenuItem)(
	({ theme }) => `
  list-style: none;
  padding: 8px;
  border-radius: 8px;
  cursor: default;
  user-select: none;

  &:last-of-type {
    border-bottom: none;
  }

  &.${menuItemClasses.focusVisible} {
    outline: 3px solid ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[100]};
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  }

  &.${menuItemClasses.disabled} {
    color: ${theme.palette.mode === 'dark' ? grey[700] : grey[400]};
  }

  &:hover:not(.${menuItemClasses.disabled}) {
    background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[100]};
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  }
  `
);

const TriggerButton = styled(MenuButton)(
	({ theme }) => `
  font-family: IBM Plex Sans, sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 4px 14px;
  line-height: 1.5;
  background: transparent;
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
  color: ${theme.palette.mode === 'dark' ? blue[300] : blue[500]};
  cursor: pointer;

  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &:hover {
    background: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
    border-color: ${theme.palette.mode === 'dark' ? grey[600] : grey[300]};
  }

  &:focus-visible {
    border-color: ${blue[400]};
    outline: 3px solid ${theme.palette.mode === 'dark' ? blue[500] : blue[200]};
  }
  `
);

function Layout(props) {
	const { window, children, title } = props;
	const [mobileOpen, setMobileOpen] = React.useState(false);
	const navigate = useNavigate();
	const [selectedIndex, setSelectedIndex] = React.useState(1);
	const { agentlogin } = useSelector((state) => state.user);
	const dispatch = useDispatch();

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};
	const handleListItemClick = (event, index) => {
		setSelectedIndex(index);
		console.log('first', index);
		if (index === 0) {
			navigate('/dashboard');
		} else if (index === 1) {
			navigate('/profile');
		} else if (index === 2) {
			navigate('/changepassword');
		} else if (index === 3) {
			navigate('/dashboard');
		} else if (index === 4) {
			navigate('/transaction');
		} else if (index === 5) {
			navigate('/booking');
		}
	};
	useEffect(() => {
		// window.scrollTo(0, 0);
		if (agentlogin?.status === 200) {
			dispatch(
				agentbookinghistoryDispatch(
					agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.id
				)
			);
			dispatch(
				agenttransactionhistoryDispatch(
					agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.id
				)
			);
			dispatch(
				walletBalanceAgentDispatch(
					agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.email,
					agentlogin &&
						agentlogin.result &&
						agentlogin.result.result &&
						agentlogin.result.result.id
				)
			);
		}
	}, []);

	const drawer = (
		<div>
			<Toolbar onClick={() => navigate('/')}>
				<img src={logo} style={{ borderRadius: 5 }} />
			</Toolbar>
			<Divider />
			<List>
				{[
					'Dashboard',
					'Profile',
					'Change Password',
					'Manage Markup',
					'Transaction History',
					'Booking History',
				].map((text, index) => (
					<InternalLink key={text} disablePadding>
						<ListItemButton
							selected={selectedIndex === index}
							onClick={(event) => {
								handleListItemClick(event, index);
							}}>
							<ListItemIcon>
								{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
							</ListItemIcon>
							<ListItemText primary={text} />
						</ListItemButton>
					</InternalLink>
				))}
			</List>
			<Divider />
			<List>
				{['Sector List', 'Add Sector'].map((text, index) => (
					<InternalLink key={text} disablePadding>
						<ListItemButton>
							<ListItemIcon>
								{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
							</ListItemIcon>
							<ListItemText primary={text} />
						</ListItemButton>
					</InternalLink>
				))}
			</List>
			<List>
				{['Logout'].map((text, index) => (
					<InternalLink key={text} disablePadding>
						<ListItemButton>
							<ListItemIcon>
								{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
							</ListItemIcon>
							<ListItemText primary={text} />
						</ListItemButton>
					</InternalLink>
				))}
			</List>
		</div>
	);

	const container =
		window !== undefined ? () => window().document.body : undefined;

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<AppBar
				position='fixed'
				sx={{
					width: { sm: `calc(100% - ${drawerWidth}px)` },
					ml: { sm: `${drawerWidth}px` },
					backgroundColor: 'white',
				}}>
				<Toolbar>
					<IconButton
						color='inherit'
						aria-label='open drawer'
						edge='start'
						onClick={handleDrawerToggle}
						sx={{ mr: 2, display: { sm: 'none' } }}>
						<MenuIcon />
					</IconButton>
					<Dropdown>
						<Box
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								width: '100%',
								alignItems: 'center',
							}}>
							<Typography
								variant='h6'
								noWrap
								component='div'
								style={{ color: 'black' }}>
								{title}
							</Typography>
							<TriggerButton>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<span style={{ color: 'black' }}>Hi</span>
									<span
										style={{
											color: 'black',
											fontWeight: 'bold',
											marginLeft: 5,
										}}>
										Nitish
									</span>
									<Avatar
										alt='Nitish'
										src='https://mui.com/static/images/avatar/2.jpg'
										sx={{ marginLeft: 1 }}
									/>
								</Box>
							</TriggerButton>
						</Box>
						<Menu slots={{ listbox: StyledListbox }}>
							<StyledMenuItem>Profile</StyledMenuItem>
							<StyledMenuItem>My account</StyledMenuItem>
							<StyledMenuItem>Log out</StyledMenuItem>
						</Menu>
					</Dropdown>
				</Toolbar>
			</AppBar>
			<Box
				component='nav'
				sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
				aria-label='mailbox folders'>
				{/* The implementation can be swapped with js to avoid SEO duplication of links. */}
				<Drawer
					container={container}
					variant='temporary'
					open={mobileOpen}
					onClose={handleDrawerToggle}
					ModalProps={{
						keepMounted: true, // Better open performance on mobile.
					}}
					sx={{
						display: { xs: 'block', sm: 'none' },
						'& .MuiDrawer-paper': {
							boxSizing: 'border-box',
							width: drawerWidth,
							backgroundColor: 'rgb(52, 49, 76)',
						},
					}}>
					{drawer}
				</Drawer>
				<Drawer
					variant='permanent'
					sx={{
						display: { xs: 'none', sm: 'block' },
						'& .MuiDrawer-paper': {
							boxSizing: 'border-box',
							width: drawerWidth,
							backgroundColor: 'rgb(52, 49, 76)',
						},
					}}
					open>
					{drawer}
				</Drawer>
			</Box>
			<Box
				component='main'
				sx={{
					flexGrow: 1,
					p: 3,
					width: { sm: `calc(100% - ${drawerWidth}px)` },
				}}>
				<Toolbar />
				{children}
			</Box>
		</Box>
	);
}

Layout.propTypes = {
	/**
	 * Injected by the documentation to work in an iframe.
	 * You won't need it on your project.
	 */
	window: PropTypes.func,
};

export default Layout;
